import { render, staticRenderFns } from "./supportSvg.vue?vue&type=template&id=5f5871fb"
import script from "./supportSvg.vue?vue&type=script&lang=js"
export * from "./supportSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports